import { Notification } from 'referral-types';

import ChevronDownIcon from '@heroicons/react/20/solid/ChevronDownIcon';
import ChevronUpIcon from '@heroicons/react/20/solid/ChevronUpIcon';
import classNames from 'classnames';
import { useState } from 'react';

import { getCornerStyleClassname, Size } from '../../constants';
import { LoadingLines } from '../_misc/loaders/LoadingLines';
import { ThemeBackground, ThemePopup, ThemeText } from '../../context/theme/ThemeConstantsUpdated';
import { useTheme } from '../../context/theme/useTheme';

const { divideBackground } = ThemeBackground;
const { divide } = ThemePopup;
const { secondaryText } = ThemeText;

export const NotificationPanel = (props: Props) => {
  const { notifications, isPopup } = props;
  const { isDarkMode } = useTheme();

  const [expandedNotifications, setExpandedNotifications] = useState<Array<string>>([]);

  return notifications && notifications.length > 0 ? (
    <div className={classNames(isPopup ? divide : divideBackground, 'divide-y')}>
      {notifications.map((o, i) => (
        <button
          className={classNames(
            secondaryText,
            isDarkMode ? 'hover:bg-white/10' : 'hover:bg-black/10',
            i === notifications.length - 1 && getCornerStyleClassname(Size.sm),
            'flex w-full flex-col rounded-t-none px-3 text-left text-sm md:px-5'
          )}
          onClick={() =>
            setExpandedNotifications((prev) => (prev.includes(o.id) ? prev.filter((p) => p !== o.id) : [...prev, o.id]))
          }
        >
          <div className="flex items-center justify-between">
            <h4 className="grow py-3 font-medium">{o.title}</h4>
            <div>
              {expandedNotifications.includes(o.id) ? (
                <ChevronUpIcon className="h-6 w-6" />
              ) : (
                <ChevronDownIcon className="h-6 w-6" />
              )}
            </div>
          </div>

          {expandedNotifications.includes(o.id) && (
            <div className="pb-4">
              <span>{o.message}</span>
            </div>
          )}
        </button>
      ))}
    </div>
  ) : (
    <div className="flex items-center justify-center px-3 py-5">
      {notifications == null ? <LoadingLines /> : <span className={classNames(secondaryText)}>No notifications.</span>}
    </div>
  );
};

type Props = {
  notifications?: Array<Notification>;
  isPopup?: boolean;
};
